/**
 * Toggle header search panels (desktop + mobile each have their own shell via aria-controls).
 * Uses .is-header-search-open / .is-header-search-filled on the nearest .js-header ancestor.
 */

function updateHeaderSearchToggleUi(button, isOpen) {
	button.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
	button.querySelectorAll('.switch-icon:not(.switch-icon--close)').forEach((el) => {
		el.classList.toggle('is-active', !isOpen);
	});
	button.querySelectorAll('.switch-icon.switch-icon--close').forEach((el) => {
		el.classList.toggle('is-active', isOpen);
	});
	button.querySelectorAll('.header-search-toggle-text-open').forEach((el) => {
		el.classList.toggle('hidden!', isOpen);
	});
	button.querySelectorAll('.header-search-toggle-text-close').forEach((el) => {
		el.classList.toggle('hidden!', !isOpen);
	});
}

function syncHeaderSearchFilled(header) {
	if (!header) {
		return;
	}
	const shell = header.querySelector('.header-search-shell');
	const input = shell ? shell.querySelector('input[name="_search"]') : null;
	const filled = input && input.value.trim().length > 0;
	header.classList.toggle('is-header-search-filled', Boolean(filled));
}

function closeAllHeaderSearch() {
	document.querySelectorAll('.js-header').forEach((header) => {
		header.classList.remove('is-header-search-open', 'is-header-search-filled');
	});
	document.querySelectorAll('.header-search-shell').forEach((shell) => {
		shell.setAttribute('aria-hidden', 'true');
	});
	document.querySelectorAll('.js-header-search-toggle').forEach((btn) => {
		updateHeaderSearchToggleUi(btn, false);
	});
}

function wireHeaderSearchInput(shell) {
	const header = shell.closest('.js-header');
	const input = shell.querySelector('input[name="_search"]');
	if (!header || !input || input.dataset.headerSearchWired === '1') {
		return;
	}
	input.dataset.headerSearchWired = '1';
	input.addEventListener('input', () => {
		syncHeaderSearchFilled(header);
	});
	input.addEventListener('change', () => {
		syncHeaderSearchFilled(header);
	});
}

document.querySelectorAll('.header-search-shell').forEach((shell) => {
	wireHeaderSearchInput(shell);
});

document.querySelectorAll('.js-header-search-toggle').forEach((button) => {
	const shellId = button.getAttribute('aria-controls');
	if (!shellId) {
		return;
	}
	const shell = document.getElementById(shellId);
	if (!shell) {
		return;
	}
	wireHeaderSearchInput(shell);

	button.addEventListener('click', (e) => {
		e.preventDefault();
		const header = button.closest('.js-header');
		const isOpen = header ? header.classList.contains('is-header-search-open') : false;
		if (!isOpen) {
			closeAllHeaderSearch();
			if (header) {
				header.classList.add('is-header-search-open');
				syncHeaderSearchFilled(header);
			}
			shell.setAttribute('aria-hidden', 'false');
			updateHeaderSearchToggleUi(button, true);
			const input = shell.querySelector('input[name="_search"]');
			if (input) {
				input.focus();
			}
		} else {
			if (header) {
				header.classList.remove('is-header-search-open', 'is-header-search-filled');
			}
			shell.setAttribute('aria-hidden', 'true');
			updateHeaderSearchToggleUi(button, false);
		}
	});
});

document.addEventListener('keyup', (e) => {
	if (e.key !== 'Escape') {
		return;
	}
	const anyOpen = Array.from(document.querySelectorAll('.js-header')).some((h) => h.classList.contains('is-header-search-open'));
	if (!anyOpen) {
		return;
	}
	closeAllHeaderSearch();
});

function initHeaderSearchFilledFromQuery() {
	document.querySelectorAll('.header-search-shell').forEach((shell) => {
		const header = shell.closest('.js-header');
		syncHeaderSearchFilled(header);
	});
}

if (document.readyState === 'loading') {
	document.addEventListener('DOMContentLoaded', initHeaderSearchFilledFromQuery);
} else {
	initHeaderSearchFilledFromQuery();
}
